/*--------------------------------------------------------------
# Custom scripts for template
--------------------------------------------------------------*/

// get section height divide by 2 and minus half height of shape
// add above calc value as top value CSS

// Wait until the document is fully loaded
document.addEventListener("DOMContentLoaded", function() {
    // Select all sections with the 'text-accordion' class
    const sections = document.querySelectorAll(".text-accordion");

    // Loop through each section
    sections.forEach(section => {
        // Find the image within the current section
        const image = section.querySelector(".block-shape");

        // Check if an image is found within the section
        if (image) {
            // Calculate half of the section height
            const sectionHalfHeight = section.offsetHeight / 2;

            // Calculate half of the image height
            const imageHalfHeight = image.offsetHeight / 2;

            // Calculate the top position value for this specific section and image
            const topPosition = sectionHalfHeight - imageHalfHeight;

            // Apply the calculated value to the image's top CSS property
            image.style.top = `${topPosition}px`;
        }
    });
});

// scroll to opened accordion
document.addEventListener('DOMContentLoaded', function () {
    const accordionItemsToBeFocused = document.querySelectorAll('.accordion-collapse');
    const inPageNavExists = document.querySelector('.in-page-nav') !== null;

    accordionItemsToBeFocused.forEach((el) => {
        el.addEventListener('shown.bs.collapse', () => {
            const header = el.previousElementSibling;
            const accordionItem = el.closest('.accordion-item');

            if (header && accordionItem) {
                const rect = accordionItem.getBoundingClientRect();
                const fullyInView = rect.top >= 0 && rect.bottom <= window.innerHeight;

                // Only scroll if not fully in view
                if (!fullyInView) {
                    let offset = 24;

                    if (inPageNavExists) {
                        offset += 55;
                    }

                    if (window.innerWidth > 782) {
                        if (document.body.classList.contains('admin-bar')) {
                            offset += 32;
                        }

                        // if (document.body.classList.contains('header-show')) {
                        //     offset += 86;
                        // }
                    } else if (window.innerWidth <= 575) {
                        offset = 24 + 117;
                    } else if (inPageNavExists) {
                        offset = 55 + 24;
                    }

                    const headerOffset = header.getBoundingClientRect().top + window.scrollY - offset;

                    window.scrollTo({
                        top: headerOffset,
                        behavior: 'smooth'
                    });
                }
            }
        });
    });
});

